import React from "react";

const ProjectAboutLacasa = ({ description, builderName }) => {
  return (
    <div className="">
      {/* Header Section */}
      <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 md:p-8 mx-auto w-full border">
        <h2 className="font-medium tracking-[0.01em] leading-[150%] text-lg sm:text-xl md:text-2xl lg:text-[24px] mb-1 sm:mb-2 md:mb-3 lg:mb-4 text-[#031722]">
          About {builderName ? builderName : "Project"}
        </h2>

        <div className="border-t-2 border-gray-200 mt-3 sm:mt-4"></div>

        {/* Description Text */}
        <div className="mt-3 sm:mt-4 space-y-3 sm:space-y-4 font-poppins font-normal text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] tracking-wider text-[#858585] text-justify w-full sm:w-[95%] md:w-[90%] lg:w-full">
          {description ? (
            <p className="font-poppins font-normal tracking-[0.01em] leading-[150%] text-sm sm:text-base xl:text-[16px] mb-3 sm:mb-4 text-[#858585]">
              {description}
            </p>
          ) : (
            <>
              <div className="bg-[#f9fafb] border border-gray-200 rounded-lg p-5 sm:p-6 md:p-7 text-center">
                <p className="text-[#999] text-base sm:text-lg font-medium">
                  No description available for this project.
                </p>
                <p className="text-[#777] text-sm sm:text-base mt-2">
                  The project details will be updated soon.
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectAboutLacasa;
